export { default } from '../../../stories-details/[storyId]/[...storyDetails]';
